import React from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { useRecommendedTemplates } from '../useRecommendedTemplates';
import RecommendedSection from '../RecommendedSection';

interface Props {
  isMobileView?: boolean;
}

const YouMayAlsoLike: React.FC<Props> = ({ isMobileView = false }) => {
  const { t } = useTranslation();
  const { template } = useTemplateContext();
  const { data: recommendations, isLoading } =
    useRecommendedTemplates(template);

  if (isLoading || !recommendations || recommendations.length === 0) {
    return null;
  }

  return (
    <RecommendedSection
      title={t('marketplace.template-page.you-may-also-like.title')}
      templates={recommendations}
      sectionType="you_may_also_like"
      dataHook="you-may-also-like"
      isMobileView={isMobileView}
    />
  );
};

export default YouMayAlsoLike;
